<!-- Product Image -->
@if (product?.pdpLinkFlag) {
  <a [routerLink]="{cxRoute:'product',params:product}|cxUrl"
    class="cx-product-image-container" tabindex="-1">
    <cx-media class="cx-product-image" [container]="product.images?.PRIMARY || product.images" format="product"
    [alt]="product.summary"></cx-media>
  </a>
}
@if (!product?.pdpLinkFlag) {
  <a class="cx-product-image-container no-cursor" tabindex="-1">
    <cx-media class="cx-product-image" [container]="product.images?.PRIMARY || product.images" format="product"
    [alt]="product.summary"></cx-media>
  </a>
}

<!-- Product List -->
<div class="product-list" [ngClass]="isLoggedIn ? 'user-logged' : 'user-not-logged'">

  <!-- Compare Checkbox -->
  @if (product?.pdpLinkFlag) {
    <div class="compare_checkbox"></div>
  }

  <!-- Product Code -->
  @if (product?.pdpLinkFlag) {
    <a [routerLink]="{cxRoute:'product',params:product}|cxUrl" class="cx-product-name">
      @if (product?.code) {
        <label class="product-code"
        [innerHtml]="product.code | searchHighlight:searchQuery"></label>
      }
    </a>
  }
  @if (!product?.pdpLinkFlag) {
    <a class="cx-product-name no-cursor">
      @if (product?.code) {
        <label class="product-code"
        [innerHtml]="product.code | searchHighlight:searchQuery"></label>
      }
    </a>
  }

  <!-- Type Number -->
  @if (product?.typenumber) {
    <label class="label-style"
    [innerHtml]="product.typenumber | searchHighlight:searchQuery"></label>
  }

  <!-- Name HTML -->
  @if (product?.nameHtml) {
    <label class="label-style"
    [innerHtml]="product.nameHtml | searchHighlight:searchQuery"></label>
  }

  <!-- GTIN -->
  @if (product?.sapEan) {
    <label class="label-style">
      GTIN : <span [innerHtml]="product.sapEan | searchHighlight:searchQuery"></span>
    </label>
  }

  <!-- Sales Status -->
  @if (product?.salesStatusText) {
    <label class="label-style sales"
      [ngClass]="['CODE30','CODE40','code30','code40'].includes(product.salesStatusCode) ? 'green-color' : ''">
      @if (product.salesStatusText.indexOf('common.') < 0) {
        <span
        [innerHtml]="product.salesStatusText | searchHighlight:searchQuery"></span>
      }
      @if (product.salesStatusText.indexOf('common.') > -1) {
        <span>{{ product.salesStatusText | cxTranslate }}</span>
      }
    </label>
  }

  <!-- Market Type -->
  @if (product?.marketType) {
    <label class="label-style"
    [innerHtml]="product.marketType | searchHighlight:searchQuery"></label>
  }

  <!-- Replaced By -->
  @if (product?.replacedByProductCode) {
    <label class="label-style">
      <span class="label-style">{{ product.replaceByText | cxTranslate }}</span>
      <a class="replaceByText m-l" [href]="product.replacedByPDPUrl"
      [innerHtml]="product.replacedByProductCode | searchHighlight:searchQuery"></a>
    </label>
  }

  <!-- IMPP -->
  @if (product?.imppList?.[0]?.split(':').length > 1 && product?.imppText) {
    <label class="d-flex">
      <span class="label-style">{{ product.imppText | cxTranslate }}</span>
      @if (product.imppList[0].split(':')[2] === 'false') {
        <span class="imp-value m-l"
        [innerHtml]="product.imppList[0].split(':')[0] | searchHighlight:searchQuery"></span>
      }
      @if (product.imppList[0].split(':')[2] === 'true') {
        <a class="imp-value m-l"
          [href]="product.imppList[0].split(':')[1]"
        [innerHtml]="product.imppList[0].split(':')[0] | searchHighlight:searchQuery"></a>
      }
    </label>
  }

  <!-- Price Section -->
  @if (product?.customerPriceText || product?.netPriceText || product?.coreDepositeText) {
    <div class="price-outer"
      [ngClass]="isLoggedIn ? 'user-logged' : 'user-not-logged'">
      @if (product?.customerPriceText) {
        <label class="label-style d-flex justify-content-between">
          {{ product.customerPriceText | cxTranslate }}&nbsp;
          @if (!product.listPrice?.formattedValue || product.listPrice.formattedValue.indexOf('-') > -1) {
            <span class="font-bold"
              >
              @if (product.customerPriceText) {
                <span>{{ 'common.basket_page_poa' | cxTranslate }}</span>
              }
            </span>
          }
          @if (product.listPrice?.formattedValue && product.listPrice.formattedValue.indexOf('-') < 0) {
            <span class="font-bold"
              >
              {{ product.listPrice.formattedValue }}&nbsp;{{ product.listPrice.currencyIso }}
            </span>
          }
        </label>
      }
      @if (product?.netPriceText) {
        <label class="label-style d-flex justify-content-between">
          {{ product.netPriceText | cxTranslate }}&nbsp;
          @if (!product.netPrice?.formattedValue || product.netPrice.formattedValue.indexOf('-') > -1) {
            <span class="font-bold"
              >
              @if (product.priceOnRequestText) {
                <span>{{ 'common.basket_page_poa' | cxTranslate }}</span>
              }
            </span>
          }
          @if (product.netPrice?.formattedValue && product.netPrice.formattedValue.indexOf('-') < 0) {
            <span class="font-bold"
              >
              {{ product.netPrice.formattedValue }}&nbsp;{{ product.netPrice.currencyIso }}
            </span>
          }
        </label>
      }
      @if (product?.coreDepositeText) {
        <label class="label-style d-flex justify-content-between">
          {{ product.coreDepositeText | cxTranslate }}&nbsp;
          @if (!product.corePrice?.formattedValue || product.corePrice.formattedValue.indexOf('-') > -1) {
            <span class="font-bold"
              >
              @if (product.priceOnRequestText) {
                <span>{{ 'common.basket_page_poa' | cxTranslate }}</span>
              }
            </span>
          }
          @if (product.corePrice?.formattedValue && product.corePrice.formattedValue.indexOf('-') < 0) {
            <span class="font-bold"
              >
              {{ product.corePrice.formattedValue }}&nbsp;{{ product.corePrice.currencyIso }}
            </span>
          }
        </label>
      }
    </div>
  }

  <!-- Compare Checkbox Component -->
  @if (product) {
    <app-check-box-compare [product]="product" class="add-checkbox-compare"></app-check-box-compare>
  }

  <!-- Buttons -->
  @if (isLoggedIn && product?.isCheckAvailibility) {
    <button (click)="checkAvailability(product.code)"
      class="fs-16 btn btn-secondary btn-block check-avl check-avl-btn">
      {{ 'common.check_availability_btn_text' | cxTranslate }}
    </button>
  }

  <app-kb-add-to-cart [showQuantity]="false" [purchasable]="product.isAddToCart" class="check-avl add-to-cart-btn"
  [productCode]="product.code" [whichPage]="'PLP'"></app-kb-add-to-cart>

  @if (isLoggedIn && product?.isQoute) {
    <button [disabled]="product.listPrice?.formattedValue"
      (click)="createAQuote(product.code)" class="btn btn-primary btn-block check-avl">
      {{ 'common.quote_create' | cxTranslate }}
    </button>
  }

  @if (product?.isContactUs && isLoggedIn && !product?.isQoute) {
    <a class="btn btn-primary btn-block check-avl"
      [href]="product.contactUsUrl" target="_blank">
      {{ 'common.pdp_page_contact_us' | cxTranslate }}
    </a>
  }

  @if (product?.isEnqury && isLoggedIn) {
    <button class="btn btn-primary btn-block check-avl enquiry-btn">
      {{ 'common.pdp_page_contact_enquiry' | cxTranslate }}
    </button>
  }
</div>

<!-- Outlet -->
<ng-template [cxOutlet]="ProductListOutlets.ITEM_ACTIONS">
  <ng-container cxInnerComponentsHost></ng-container>
</ng-template>